export const TEST_DRIVE_READY_TO_SEND = 'TEST_DRIVE_READY_TO_SEND';

export const OFFER_SENT_WITH_TEST_DRIVE = 'OFFER_SENT_WITH_TEST_DRIVE';

export const CLEAR_TEST_DRIVE = 'CLEAR_TEST_DRIVE';
